/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentStatus = {
    Pending: 'Pending',
    Reserved: 'Reserved',
    Declined: 'Declined',
    Settled: 'Settled',
    Refunded: 'Refunded',
    Voided: 'Voided'
} as const;
export type PaymentStatus = typeof PaymentStatus[keyof typeof PaymentStatus];


export function instanceOfPaymentStatus(value: any): boolean {
    for (const key in PaymentStatus) {
        if (Object.prototype.hasOwnProperty.call(PaymentStatus, key)) {
            if (PaymentStatus[key as keyof typeof PaymentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaymentStatusFromJSON(json: any): PaymentStatus {
    return PaymentStatusFromJSONTyped(json, false);
}

export function PaymentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentStatus {
    return json as PaymentStatus;
}

export function PaymentStatusToJSON(value?: PaymentStatus | null): any {
    return value as any;
}

export function PaymentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PaymentStatus {
    return value as PaymentStatus;
}

